export const ACTION_COMPLETE = 'complete';
export const ACTION_SUBMIT = 'submit';
export const ACTION_ENTRY = 'entry';
export const ACTION_FORGOT_PASSWORD_SELECTED = 'forgot password selected';
export const ACTION_LINK_EMAIL_SELECTED = 'login link email selected';
export const ACTION_LINK_EMAIL_SUBMITTED = 'login link email submitted';
export const ACTION_RESEND_LOGIN_LINK_SELECTED = 'resend login link selected';
